/* eslint-disable no-fallthrough */
import type { Action } from 'redux';
import type { ClientThunkAction } from 'client/reducers';

import { PARAMS } from 'common/constants';
import { location } from 'utils/url-helper';
import { API } from 'client/constants/actions';
import { apiRequest } from 'client/actions/api';

const { isScreenshot } = location.client;

type BaseProperties = {
	playbackId: string;
	videoId: string;
	videoPlayerId: string;
};

export type VideoEvent<T = BaseProperties> =
	| {
			event: 'watchtime';
			properties: T & {
				watchtimeLocation: number;
				watchtimeJumped: boolean;
			};
	  }
	| {
			event: 'impression';
			properties: T;
	  }
	| {
			event: 'play';
			properties: T;
	  };

export function sendVideoEvent(event: VideoEvent): ClientThunkAction<Action, Error | boolean> {
	return (dispatch, getState) => {
		const storyId = getState().story.story?.id;

		if (isScreenshot() || !storyId) {
			return Promise.resolve(false);
		}

		return dispatch(
			apiRequest({
				action: API.SEND_VIDEO_EVENT,
				params: { [PARAMS.STORY_ID]: storyId },
				data: {
					data: event,
				},
			})
		);
	};
}
